import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import IpoAccordian from '../../../components/IpoAccordian';
import CustomTable from '../../../components/customTable/customTable';
import { Link } from 'react-router-dom';
import { newsDetails } from '../../../api/IposApi';
import { formatDate } from '../../../components/CommonFunction';
import TruncatedText from './TruncatedText';

export const NewsDetailsData = () => {

    const { ipoDetailData, ipoDetailLoading } = useSelector(state => state.ipoDetail);
    const [news, setNews] = useState([]);
    const [isExpanded, setIsExpanded] = useState(false);

    const isFirstRun = useRef(true);

    useEffect(() => {
        // if (isFirstRun.current) {
        //     isFirstRun.current = false;
        //     return; // Prevents first duplicate call
        // }
        let request = {
            page: 1,
            perPage: 30
        }
        newsDetails(request).then((response) => {
            if (response && response.meta && response.meta.status_code === 200) {
                setNews(response?.data?.results)
            }
        })
    }, [])
    return (
        <>
            <div className='mainDetailsPage'>

                <div className='content'>
                    <p className='mb-0'>
                        Track all the latest updates and news of {ipoDetailData?.company_name} IPO.
                    </p>

                    <section className='content-description news-containt'>
                        {Array.isArray(news) && news.length > 0 ? (
                            news.map((item) => (
                                <div key={item.id} className='mt-4 mb-5'>
                                    <h3>
                                        <Link
                                            className='content-link'
                                            to={item.news_url || '#'}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            {item.title}
                                        </Link>
                                    </h3>

                                    {/* <p className='p-2 '>{formatDate(item.created_at)}</p> */}
                                    {/* <div>
                                        <p className='line-clamp'>{item.description}</p>
                                    </div> */}

                                    <TruncatedText text={item.description } maxLines={3}  newsUrl={item.news_url}/>
                                    
                                    {/* <div>
                                        <div className="read-more-wrapper">
                                            <p className={`line-clamp ${isExpanded ? "expanded" : ""}`}>
                                                {item.description.length > 350
                                                    ? item.description.slice(0, 350) + "..."
                                                    : item.description}
                                            </p>
                                            {item.description.length > 350 && (
                                                <Link
                                                    to={item.news_url || "#"}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="read-more-link"
                                                >
                                                    Read More
                                                </Link>
                                            )}
                                        </div>
                                    </div> */}

                                    <hr></hr>
                                </div>
                            ))
                        ) : (
                            <div className='border p-4 news-containt mb-3'>
                                <div className='flex justify-center items-center'>
                                    <p>No news available</p>
                                </div>
                            </div>
                        )}
                    </section>
                </div>
            </div>
        </>
    )
}
